import { render } from "./FloatingCard.vue?vue&type=template&id=6a6f4efe"
import script from "./FloatingCard.vue?vue&type=script&lang=js"
export * from "./FloatingCard.vue?vue&type=script&lang=js"

import "./FloatingCard.vue?vue&type=style&index=0&id=6a6f4efe&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__